/* eslint-env mocha
 * Onboarding options for all packages form rendering
 */
export default {
  data: function () {
    return {
      amount_exc_vat_copy: 'Amount excl. VAT',
      vat_copy: 'VAT',
      total_amount_copy: 'Total amount to be paid',
      payment_tabs: ['visa', 'mastercard', 'amex'],
      card_payment_types: [
        {
          name: 'VISA',
          value: 'visa'
        },
        {
          name: 'Mastercard',
          value: 'mastercard'
        },
        {
          name: 'American Express',
          value: 'amex'
        }
      ],
      unavailable_org_msg: ' has already been claimed on Hellopeter. You will need to contact the owner of this account to gain access, or change your business selection to continue.',
      thank_you_badge: '/static/img/packages/like_icon.svg',
      thank_you_heading: 'Your business profile <br/> is in our hands.',
      free_thank_you_msg: '<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>' +
      'Our team will review your information. Once this is done, your account <br/>will be activated and a welcome email ' +
      'will be sent to %email_address% to get you started.',
      eft_thank_you_msg: '<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>' +
      'Once we receive your EFT payment, your account will be activated <br/>and a welcome email will be sent to %email_address% to get you started.',
      cc_thank_you_msg: '<span class="has-text-weight-bold">Thank you for creating a business account on Hellopeter!</span><br/>' +
      'We\'re glad to have you on board. %signin_url% to Portal to get started.',
      create_account_title: 'Create your account',
      billing_info_title: 'Billing information',
      cc_payment_title: 'Make credit card payment',
      eft_payment_title: 'EFT payment',
      eft_payment_subtitle: 'Please make payment to the following bank account',
      billing_info_subtitle: 'This information will be displayed on your invoice.',
      proof_of_payment_to: 'Send proof of payment to ' + '<span class="underline">accounts@hellopeter.com</span>',
      eft_hp_banking_details: [
        {
          'Bank': 'Nedbank',
          'Account number': '1084 211 319',
          'Account name': 'TKJ Design (Pty) Ltd T/A hellopeter.com',
          'Branch': '198765, Business Southern Peninsula',
          'Your reference': '[generated ref no.]'
        }],
      packages: [
        {
          name: 'Free',
          badge_title: 'YOUR <span class="has-text-weight-bold">FREE</span> ACCOUNT',
          badge_image: '/static/img/packages/free_icon.svg',
          monthly_price: 'Free'
        },
        {
          name: 'Lite',
          badge_title: 'YOUR <span class="has-text-weight-bold">LITE</span> ACCOUNT',
          badge_image: '/static/img/packages/lite_icon.svg',
          monthly_price: 'R699',
          annual_price: 'R8,388'
        },
        {
          name: 'Pro',
          badge_title: 'YOUR <span class="has-text-weight-bold">PRO</span> ACCOUNT',
          badge_image: '/static/img/packages/pro_icon.svg',
          annual_price: 'R31,118'
        },
        {
          name: 'Enterprise',
          badge_title: 'YOUR <span class="has-text-weight-bold">ENTERPRISE</span> ACCOUNT',
          badge_image: '/static/img/packages/enterprise_icon.svg',
          annual_price: 'R95,988'
        }
      ],
      create_account_sectional_subtitles: [{
        'Business details': 'This information will be displayed on your business profile page',
        'User details': 'Create an account to access the Hellopeter business Portal'
      }],
      create_account: [
        {
          'Business details': [
            {
              name: 'Business name',
              element_name: 'business_name',
              form_element: 'input',
              type: 'text',
              ajax_lookup: true
            },
            {
              name: 'Select industry',
              element_name: 'industry_id',
              form_element: 'select',
              type: 'select'
            }
          ],
          'User details': [
            {
              name: 'First name',
              element_name: 'business_user_firstname',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Last name',
              element_name: 'business_user_lastname',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Email address',
              element_name: 'business_user_email',
              form_element: 'input',
              type: 'email'
            },
            {
              name: 'Password',
              element_name: 'business_user_password',
              form_element: 'input',
              type: 'password'
            },
            {
              name: 'Confirm password',
              element_name: 'business_user_password_confirmation',
              form_element: 'input',
              type: 'password'
            }
          ]
        }
      ],
      billing_information: [
        {
          'billing_fields': [
            {
              name: 'Registered name',
              element_name: 'business_reg_name',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Registration number',
              element_name: 'business_reg_number',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'VAT number',
              element_name: 'business_vat_number',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Billing address',
              element_name: 'address',
              form_element: 'input',
              type: 'address'
            },
            {
              name: 'Payment method',
              element_name: 'payment_method',
              form_element: 'radio',
              elements: ['Credit Card', 'EFT'],
              elements_values: ['CREDIT_CARD', 'EFT'],
              type: 'collection'
            },
            {
              name: 'Payment frequency',
              element_name: 'payment_freq',
              form_element: 'select',
              elements: [
                {'name': 'Monthly', 'value': 'MONTHLY'},
                {'name': 'Annual', 'value': 'ANNUAL'}
              ],
              type: 'dropdown'
            },
            {
              name: 'First payment amount',
              element_name: 'include_pro_rata_with_subscription',
              form_element: 'radio',
              elements: ['(pro rata and next month\'s payment)', '(pro rata amount only)'],
              elements_values: [1, 0],
              type: 'collection'
            }
          ]
        }
      ],
      credit_card_information: [
        {
          'credit_card_fields': [
            {
              name: 'Name on Card',
              element_name: 'card_owner',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Card number',
              element_name: 'card_number',
              form_element: 'input',
              type: 'text'
            },
            {
              name: 'Expiration month',
              element_name: 'card_month',
              form_element: 'select',
              elements: [
                {'name': 'January', 'value': '01'},
                {'name': 'February', 'value': '02'},
                {'name': 'March', 'value': '03'},
                {'name': 'April', 'value': '04'},
                {'name': 'May', 'value': '05'},
                {'name': 'June', 'value': '06'},
                {'name': 'July', 'value': '07'},
                {'name': 'August', 'value': '08'},
                {'name': 'September', 'value': '09'},
                {'name': 'October', 'value': '10'},
                {'name': 'November', 'value': '11'},
                {'name': 'December', 'value': '12'}
              ],
              type: 'dropdown'
            },
            {
              name: 'Expiration year',
              element_name: 'card_year',
              form_element: 'select',
              elements: [ // TODO: dynamically generate this list
                {'name': '2018', 'value': '2018'},
                {'name': '2019', 'value': '2019'},
                {'name': '2020', 'value': '2020'},
                {'name': '2021', 'value': '2021'},
                {'name': '2022', 'value': '2022'},
                {'name': '2023', 'value': '2023'},
                {'name': '2024', 'value': '2024'},
                {'name': '2025', 'value': '2025'},
                {'name': '2026', 'value': '2026'},
                {'name': '2027', 'value': '2027'}
              ],
              type: 'dropdown'
            },
            {
              name: 'CVC number',
              element_name: 'card_cvc',
              form_element: 'input',
              type: 'text'
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/onboarding-package-forms.js